module.exports = __webpack_public_path__ + "static/img/1.f134b63.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/2/eng/1.png
// module id = 0BW+
// module chunks = 0